import { Pipe, PipeTransform } from '@angular/core';

import { Violation } from 'src/app/interfaces/Violation.interface';

@Pipe({
  name: 'violationFilter'
})
export class ViolationFilterPipe implements PipeTransform {

  getdata(item: any, searchText: string) {
    let agentFullName = item.AgentFirstName.toLowerCase() + " " + item.AgentLastName.toLowerCase();
    let result = item.ViolationName.toLowerCase().indexOf(searchText.toLowerCase()) !== -1 ||
      agentFullName.indexOf(searchText.toLowerCase()) !== -1;
    return (result);

  };

  transform(violations: any[], searchText: string) {

    if (!violations || !searchText) {
      return violations;
    }
    // return agents.filter(agent=> agent.containsString(JSON.stringify(post), this.searchWord) ) 
    return violations.filter((vio: any) => this.getdata(vio, searchText));

    // return agents.filter(agent=>
    //     agent.LanID.toLowerCase() == searchText.toLowerCase());

  }
}
